import React from "react";
import PortalShell from "./PortalShell";
import { useT } from "@/context/I18nContext";
import { isAnyAdmin, isOrgAdmin, isPlatformOwner } from "@/context/AuthContext";
import { LayoutDashboard, Users, MailPlus, Users2, LineChart, CreditCard, Settings } from "lucide-react";

/** Organisation (HR) portal. FLMs get a reduced, non-surveillance nav. */
export default function AdminShell() {
  const t = useT();
  const items = ({ roles }) => {
    const full = isOrgAdmin(roles) || isPlatformOwner(roles);
    return [
      { key: "dashboard", to: "/admin", end: true, label: t("nav.overview"), icon: LayoutDashboard },
      ...(full ? [
        { key: "users", to: "/admin/users", label: t("b2b.nav.employees"), icon: Users },
        { key: "invites", to: "/admin/invitations", label: t("nav.invites"), icon: MailPlus },
      ] : []),
      { key: "teams", to: "/admin/teams", label: t("nav.teams"), icon: Users2 },
      { key: "analytics", to: "/admin/analytics", label: t("b2b.nav.insights"), icon: LineChart },
      ...(full ? [
        { key: "billing", to: "/admin/billing", label: t("b2b.nav.licence"), icon: CreditCard },
        { key: "settings", to: "/admin/settings", label: t("b2b.nav.orgSettings"), icon: Settings },
      ] : []),
    ];
  };
  return (
    <PortalShell
      title={t("nav.business")}
      subtitle={({ orgName, roles }) => orgName || (isOrgAdmin(roles) ? t("nav.organisation") : t("b2b.nav.team"))}
      items={items}
      allow={(roles) => isAnyAdmin(roles)}
      testPrefix="admin"
      headerLabel="Admin"
    />
  );
}
